<script setup lang="ts">
import { computed } from "vue";

const props = defineProps<{
  open: boolean;
  title?: string;
  ui?: Record<string, string>;
  // 关闭前拦截：返回 false（或 resolve 为 false）阻止关闭，用于「有未保存修改时二次确认」；
  // 提供后 UModal 的 Esc/点击外部自动关闭被禁用，统一走 X 按钮 → tryClose → 确认
  beforeClose?: () => boolean | Promise<boolean>;
}>();
const emit = defineEmits<{ "update:open": [value: boolean] }>();

const isOpen = computed({
  get: () => props.open,
  set: (v) => emit("update:open", v),
});

async function tryClose(): Promise<void> {
  if (!props.beforeClose) {
    emit("update:open", false);
    return;
  }
  const ok = await props.beforeClose();
  if (ok !== false) emit("update:open", false);
}
</script>

<template>
  <UModal
    v-model:open="isOpen"
    :dismissible="!props.beforeClose"
    :ui="{
      content: 'max-w-lg',
      ...props.ui,
      header: 'px-5 py-4 border-b border-default flex items-center justify-between',
      body: 'px-5 py-4',
      footer: 'px-5 py-3 border-t border-default flex items-center justify-end gap-2',
      title: 'text-base font-semibold text-highlighted',
    }">
    <template #header>
      <span
        v-if="title"
        class="text-base font-semibold text-highlighted">
        {{ title }}
      </span>
      <UButton
        icon="i-heroicons-x-mark"
        color="neutral"
        variant="ghost"
        size="xs"
        @click="void tryClose()" />
    </template>
    <template #body>
      <slot />
    </template>
    <template
      v-if="$slots.footer"
      #footer>
      <slot name="footer" />
    </template>
  </UModal>
</template>
